import styled from "styled-components";
import { cuideoTheme } from "../../../../containers/themes/defaultTheme";

export const NightButtonsBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
`;

export const NightButton = styled.button<{ $variant: "filled" | "outlined" }>`
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border: 1px solid ${cuideoTheme.palette.secondary.main};
  ${({ $variant }) =>
    $variant === "filled"
      ? `background: ${cuideoTheme.palette.secondary.main}; color: #fff;`
      : `background: #fff; color: ${cuideoTheme.palette.secondary.main};`}
  &:hover {
    opacity: 0.85;
  }
`;
